import { NgClass } from "@angular/common";
import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { InfoComponent } from "@components/info/info.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Observable, firstValueFrom, of } from "rxjs";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { FeatureService } from "~app/common/services/feature.service";
import { TypeaheadService } from "~app/common/services/typeahead/typeahead.service";
import { TypeAhead } from "~app/common/services/typeahead/typeahead.types";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { OrderService } from "~app/features/forsaljning/order/order.service";
import { DisabledControlDirective } from "../../../../../../common/directives/disabled-control/disabled-control.directive";
import { IAlternativtHandelssortiment, IHandelssortiment, IKundorderDetailKundorderrad } from "../../../models/kundorder-detail-model";
import { AlternativaHandelssortimentComponent } from "../alternativa-handelssortiment/alternativa-handelssortiment.component";
import { KundorderradInmatningshandelssortimentComponent } from "../kundorderrad-inmatningshandelssortiment/kundorderrad-inmatningshandelssortiment.component";

@Component({
    selector: "rask-kundorderrad-handelssortiment",
    templateUrl: "./kundorderrad-handelssortiment.component.html",
    styleUrls: ["./kundorderrad-handelssortiment.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        SelectorComponent,
        NgClass,
        DisabledControlDirective,
        NgbPopover,
        InfoComponent,
        AlternativaHandelssortimentComponent,
        KundorderradInmatningshandelssortimentComponent,
        TranslatePipe
    ]
})
export class KundorderradHandelssortimentComponent {
    @Input() beraknatInmatningshandelssortiment: IHandelssortiment;
    @Input() form: UntypedFormGroup;

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("alternativaHandelssortiment") handelssortiment: IAlternativtHandelssortiment[];
    @Input() inmatningshandelssortiment: IHandelssortiment;
    @Input() kundorderrad: IKundorderDetailKundorderrad;
    @Input() kundorderradId: number;
    @Input() newMode: boolean;
    @Input() readonly = false;
    @Input() showLabels = true;
    @Input() validation: IValidationScope;
    private readonly featureService = inject(FeatureService);
    private readonly orderService = inject(OrderService);
    private readonly translateService = inject(TranslateService);
    private readonly typeaheadService = inject(TypeaheadService);

    alternativaHandelssortimentChanged(selection) {
        this.form.controls.alternativaHandelssortiment.setValue(selection);
    }

    gallandeInmatningshandelssortiment()  {
        return this.inmatningshandelssortiment?.violId || this.beraknatInmatningshandelssortiment.violId;
    }

    handelssortimenViewFormatter = (item: ITypeAheadResult) => item.namn;

    handelssortimentDisabled = (item) => !item.aktiv;

    inmatningshandelssortimentChanged(inmatningshandelssortiment) {
        this.form.controls.inmatningshandelssortiment.setValue(inmatningshandelssortiment);
        const violId = inmatningshandelssortiment?.violId || this.beraknatInmatningshandelssortiment.violId;
        firstValueFrom(this.orderService.checkExtrarraderRegelverk(violId, this.kundorderrad.mottagningsplats.id)).then((response) => {
            this.kundorderrad.matchesViol3Regelverk = response;
        });
    }

    searchForHandelssortiment = (input: string): Observable<ITypeAheadResult[]> => input.length < 3
        ? this.getPreload(TypeAhead.Handelssortiment)
        : this.orderService.searchForHandelssortimentTypeAhead(input);

    private getPreload<T>(type: string): Observable<T[]> {
        const defaultText = this.translateService.instant("KUNDORDER_DETAIL_TYPE_AHEAD_HELP_TEXT");
        return of(this.typeaheadService.getPreload<T>(type, defaultText));
    }
}
